import { apiGet, apiSend } from './client';
import type { Environment } from '../constants';
import type { IAskConversation, IAskFeedbackInput, IAskInput, IAskRequest } from '../types';

export const createAsk = (
  environment: Environment,
  input: IAskInput,
): Promise<{ data: IAskRequest }> => apiSend(environment, '/ask', 'POST', input);

export const getAsk = (environment: Environment, id: string): Promise<{ data: IAskRequest }> =>
  apiGet(environment, `/ask/${encodeURIComponent(id)}`);

export const sendAskFeedback = (
  environment: Environment,
  id: string,
  input: IAskFeedbackInput,
): Promise<{ data: IAskRequest }> =>
  apiSend(environment, `/ask/${encodeURIComponent(id)}/feedback`, 'POST', input);

export const listConversations = (
  environment: Environment,
  tenant: string,
): Promise<{ data: IAskConversation[] }> =>
  apiGet(environment, `/ask/conversations?tenant=${encodeURIComponent(tenant)}`);

export const getThread = (environment: Environment, id: string): Promise<{ data: IAskRequest[] }> =>
  apiGet(environment, `/ask/conversations/${encodeURIComponent(id)}`);

export const deleteConversation = (
  environment: Environment,
  id: string,
): Promise<{ data: { id: string } }> =>
  apiSend(environment, `/ask/conversations/${encodeURIComponent(id)}`, 'DELETE');
